module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Couch-4bf43384d34349ad10dc6c7b1ce1ed7c27932b5f92d25e92e60cf7451750d97b.svg";